export default __webpack_public_path__ + "static/media/header.fd46313a.jpg";